/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: -YS8G3Mc1nL8
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import ContainerInTab from "../../ContainerInTab"; // plasmic-import: _lT-Lq7an5i5/component
import WebDock from "../../WebDock"; // plasmic-import: EtVLWfl2KEmA/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebDemo.module.css"; // plasmic-import: -YS8G3Mc1nL8/css
import Icon30Icon from "./icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "./icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "./icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon32Icon from "./icons/PlasmicIcon__Icon32"; // plasmic-import: dWHMt3F1tCmW/icon
import Icon33Icon from "./icons/PlasmicIcon__Icon33"; // plasmic-import: h408FMoSv0qx/icon
import Icon15Icon from "./icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "./icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon
import Icon26Icon from "./icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p demo.",
    openGraph: {
      title: "o21p demo."
    },
    twitter: {
      card: "summary",
      title: "o21p demo."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebDemo__VariantProps = new Array();

export const PlasmicWebDemo__ArgProps = new Array();

const $$ = {};

function PlasmicWebDemo__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.root
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              className={classNames("__wab_instance", sty.webTab)}
              tabContent={
                <ContainerInTab
                  data-plasmic-name={"containerInTab"}
                  data-plasmic-override={overrides.containerInTab}
                  children={null}
                  className={classNames("__wab_instance", sty.containerInTab)}
                  padding={"global"}
                />
              }
              tabDock={
                <WebDock
                  data-plasmic-name={"webDock"}
                  data-plasmic-override={overrides.webDock}
                  className={classNames("__wab_instance", sty.webDock)}
                  modulesWrapper={
                    <React.Fragment>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__li1B7
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__iTzHa
                            )}
                          >
                            <Icon30Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__aUfCd
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebHomepage"] = true
                            ? (() => {
                                const actionArgs = { destination: `/` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebHomepage"] != null &&
                            typeof $steps["goToWebHomepage"] === "object" &&
                            typeof $steps["goToWebHomepage"].then === "function"
                          ) {
                            $steps["goToWebHomepage"] =
                              await $steps["goToWebHomepage"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__tn8Ep
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___0Yxda
                            )}
                          >
                            <Icon23Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__lB2Vv
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebRoadmap"] = true
                            ? (() => {
                                const actionArgs = { destination: `/roadmap` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebRoadmap"] != null &&
                            typeof $steps["goToWebRoadmap"] === "object" &&
                            typeof $steps["goToWebRoadmap"].then === "function"
                          ) {
                            $steps["goToWebRoadmap"] =
                              await $steps["goToWebRoadmap"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___2FGy
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__xsbZq
                            )}
                          >
                            <Icon34Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___6B2In
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebTheIndependent"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/the-independent`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebTheIndependent"] != null &&
                            typeof $steps["goToWebTheIndependent"] ===
                              "object" &&
                            typeof $steps["goToWebTheIndependent"].then ===
                              "function"
                          ) {
                            $steps["goToWebTheIndependent"] =
                              await $steps["goToWebTheIndependent"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__efaHi
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___3M6KL
                            )}
                          >
                            <Icon32Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__ypJVz
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                        status={"selected"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___7VzYq
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___84Wr5
                            )}
                          >
                            <Icon33Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__gHXv
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebFiles"] = true
                            ? (() => {
                                const actionArgs = { destination: `/files` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebFiles"] != null &&
                            typeof $steps["goToWebFiles"] === "object" &&
                            typeof $steps["goToWebFiles"].then === "function"
                          ) {
                            $steps["goToWebFiles"] =
                              await $steps["goToWebFiles"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__zdwUd
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__rFtNw
                            )}
                          >
                            <Icon15Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__oUzRs
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSupport"] != null &&
                            typeof $steps["goToWebSupport"] === "object" &&
                            typeof $steps["goToWebSupport"].then === "function"
                          ) {
                            $steps["goToWebSupport"] =
                              await $steps["goToWebSupport"];
                          }
                        }}
                        status={"_default"}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__zk8LL
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__ds36B
                          )}
                        />
                      </div>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__kF5T2
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__jA36U
                            )}
                          >
                            <Icon27Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__uxibs
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebGallery"] = true
                            ? (() => {
                                const actionArgs = { destination: `/gallery` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebGallery"] != null &&
                            typeof $steps["goToWebGallery"] === "object" &&
                            typeof $steps["goToWebGallery"].then === "function"
                          ) {
                            $steps["goToWebGallery"] =
                              await $steps["goToWebGallery"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__vwhQt
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__gXsD
                            )}
                          >
                            <Icon26Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__k8Imm
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebPartnersCommunity"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/partners-community`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebPartnersCommunity"] != null &&
                            typeof $steps["goToWebPartnersCommunity"] ===
                              "object" &&
                            typeof $steps["goToWebPartnersCommunity"].then ===
                              "function"
                          ) {
                            $steps["goToWebPartnersCommunity"] =
                              await $steps["goToWebPartnersCommunity"];
                          }
                        }}
                        status={"_default"}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <React.Fragment>
                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary___5W5Nw
                        )}
                        color={"tertiary"}
                        content={"don't book a demo"}
                        onClick={async () => {
                          const $steps = {};
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__arGr1
                        )}
                        color={"primary"}
                        content={"x"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                      />
                    </React.Fragment>
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumb1={"files."}
                      crumb2={"the independent."}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p demo."}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "containerInTab",
    "webDock"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "containerInTab",
    "webDock"
  ],

  webTab: ["webTab", "webTopNav", "breadcrumb", "containerInTab", "webDock"],
  webTopNav: ["webTopNav", "breadcrumb"],
  breadcrumb: ["breadcrumb"],
  containerInTab: ["containerInTab"],
  webDock: ["webDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebDemo__ArgProps,
          internalVariantPropNames: PlasmicWebDemo__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebDemo__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWebDemo";
  } else {
    func.displayName = `PlasmicWebDemo.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebDemo = Object.assign(
  // Top-level PlasmicWebDemo renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    containerInTab: makeNodeComponent("containerInTab"),
    webDock: makeNodeComponent("webDock"),
    // Metadata about props expected for PlasmicWebDemo
    internalVariantProps: PlasmicWebDemo__VariantProps,
    internalArgProps: PlasmicWebDemo__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/demo",
      pagePath: "/demo",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebDemo;
/* prettier-ignore-end */
